import { Subtitle, Title } from '@vrzl/ui';
import { Link } from 'react-router';


export function NotFound() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <Title>404</Title>
        <Subtitle className="mt-2">Page not found</Subtitle>
        <Link to="/" className="mt-4 inline-block text-primary-600 underline">
          Go home
        </Link>
      </div>
    </div>
  );
}
